import { getElementChild, getElementChildren, getElements } from '../Utility/Dom'

const REQUIRED_LABEL_CLASS = 'form__label--required'

export default class FormConditionService {
  private forms: NodeListOf<HTMLFormElement>

  constructor () {
    this.forms = getElements('form') as NodeListOf<HTMLFormElement>
  }

  public init (): void {
    this.forms.forEach((form) => {
      const conditionalContainers = form.querySelectorAll('[data-js=form-ctr][data-condition-field]')

      conditionalContainers.forEach((container: HTMLElement) => {
        const controllingElements = this.getControllingElements(form, container.dataset.conditionField)

        if (controllingElements.length === 0) {
          this.toggle(container, true)
          return
        }

        controllingElements.forEach((controllingElement) => {
          controllingElement.addEventListener('change', (): void => {
            this.toggle(container, this.isConditionMet(controllingElements, container.dataset.conditionValue))
          })
        })

        this.toggle(container, this.isConditionMet(controllingElements, container.dataset.conditionValue))
      })
    })
  }

  private getControllingElements (form: HTMLFormElement, fieldIdentifier: string): HTMLInputElement[] {
    const formElements = getElementChildren(form, 'form-element') as NodeListOf<HTMLInputElement>

    return Array.from(formElements).filter((formElement) => {
      return formElement.name.endsWith(`[${fieldIdentifier}]`)
    })
  }

  private hasRequiredRule (container: HTMLElement): boolean {
    const formGroup = getElementChild(container, 'form-group')

    return typeof formGroup?.dataset.msg === 'string' && formGroup.dataset.msg.includes('1221560910')
  }

  private isConditionMet (controllingElements: HTMLInputElement[], expectedValue: string): boolean {
    return controllingElements.some((controllingElement) => {
      if (controllingElement.type === 'radio' || controllingElement.type === 'checkbox') {
        return controllingElement.checked === true && controllingElement.value === expectedValue
      }

      return controllingElement.value === expectedValue
    })
  }

  private toggle (container: HTMLElement, isVisible: boolean): void {
    if (container.hidden === !isVisible) {
      return
    }

    container.hidden = !isVisible

    const formElements = getElementChildren(container, 'form-element') as NodeListOf<HTMLInputElement>

    formElements.forEach((formElement) => {
      if (isVisible === true) {
        if (formElement.dataset.conditionRequired === 'true') {
          formElement.required = true
        }

        return
      }

      // Native validation would block the submit of an invisible field whenever the
      // JavaScript bundle fails to load.
      if (formElement.required === true) {
        formElement.dataset.conditionRequired = 'true'
        formElement.required = false
      }

      if (formElement.type === 'checkbox' || formElement.type === 'radio') {
        formElement.checked = false
      } else {
        formElement.value = ''
      }
    })

    // The required marker is derived from the validators, which the server side variant
    // has already removed while the condition was unmet.
    const label = getElementChild(container, 'form-group')?.querySelector('.form__label--main, .form__label--group')
    label?.classList.toggle(REQUIRED_LABEL_CLASS, isVisible === true && this.hasRequiredRule(container))
  }
}
